// 底部导航栏组件
<template>
  <div class="footer_bar">
    <div class="inner">
      <div>
        <div class="line_title"></div>
      </div>
      <div class="flex">
        <div class="desc">
          <div class="name">{{ this.name }}</div>
          <div class="address" style="width: 350px">
            <img class="min-logo" style="width: 18px" src="../assets/local.png" />
            {{ this.site }}
          </div>
          <div class="desc_items">
            <div class="flex">
              <div class="flex-item">
                <img class="min-logo" src="../assets/phone.png" /> {{ this.phone }}
              </div>
            </div>
            <div class="flex">
              <div class="flex-item">
                <img class="min-logo" src="../assets/wechat.png" /> {{ this.wx }}
              </div>
            </div>
            <div class="flex">
              <div class="flex-item">
                <img class="min-logo" src="../assets/inbox.png" /> {{ this.email }}
              </div>
            </div>
            <!-- <div class="flex">
              <div class="flex-item">
                <img class="min-logo" src="../assets/detail.png" />简历投递 fjkkauto@163.com
              </div>
            </div> -->
          </div>
        </div>

        <div v-if="this.isZ" class="links">
          <div class="link_item_title">
            <div target="_blank" class="foot_title">产品中心</div>
          </div>
          <div class="link_item">
            <a @click="doProductRouter(2)" target="_blank">清洁系统</a>
          </div>
          <div class="link_item">
            <a @click="doProductRouter(4)" target="_blank">仪器仪表</a>
          </div>
          <div class="link_item">
            <a @click="doProductRouter(3)" target="_blank">机器人集成</a>
          </div>
          <div class="link_item">
            <a @click="doProductRouter(1)" target="_blank">配电和工业自动化元件</a>
          </div>
        </div>
        <div v-else class="linkss">
          <div class="link_item_title">
            <div target="_blank" class="foot_title">产品中心</div>
          </div>
          <div class="link_item">
            <a @click="doProductRouter(2)" target="_blank">清洁系统</a>
          </div>
          <div class="link_item">
            <a @click="doProductRouter(4)" target="_blank">仪器仪表</a>
          </div>
          <div class="link_item">
            <a @click="doProductRouter(3)" target="_blank">机器人集成</a>
          </div>
          <div class="link_item">
            <a @click="doProductRouter(1)" target="_blank">配电和工业自动化元件</a>
          </div>
        </div>
        <div v-if="this.isZ" class="links">
          <div class="link_item_title">
            <div target="_blank" class="foot_title">服务于支持</div>
          </div>
          <div class="link_item">
            <a @click="doCaseRouter()" target="_blank">资料下载</a>
          </div>
          <div class="link_item">
            <a @click="doCaseRouter()" target="_blank">售后服务</a>
          </div>
          <div class="link_item">
            <a @click="doCaseRouter()" target="_blank">技术支持</a>
          </div>
        </div>
        <div v-else class="linkss">
          <div class="link_item_title">
            <div target="_blank" class="foot_title">服务于支持</div>
          </div>
          <div class="link_item">
            <a @click="doCaseRouter()" target="_blank">资料下载</a>
          </div>
          <div class="link_item">
            <a @click="doCaseRouter()" target="_blank">售后服务</a>
          </div>
          <div class="link_item">
            <a @click="doCaseRouter()" target="_blank">技术支持</a>
          </div>
        </div>
        <div class="links" v-if="isZ">
          <div class="link_item_title">
            <div target="_blank" class="foot_title">解决方案</div>
          </div>
          <div class="link_item">
            <a @click="doService()" target="_blank">智能码垛</a>
          </div>
          <div class="link_item">
            <a @click="doService()" target="_blank">后段流水线</a>
          </div>
          <!-- <div class="link_item">
            <a @click="doService()" target="_blank">方案一</a>
          </div> -->
        </div>
        <div class="split_line"></div>
        <div class="qrcode">
          <img v-if="this.isKK" src="../assets/KK_LOGO.png" />
          <img
            v-else
            style="margin-left: 20px; width: 100%"
            src="../assets/bjlogow.png"
          />
          <div class="look-us" @click="doUsRoter()">关注我们</div>
        </div>
      </div>
      <div class="copyright">
        <span class="copy">Copyright © 2022 {{ this.name }} All rights reserved.</span>
        <a
          target="_blank"
          href="https://beian.miit.gov.cn/#/Integrated/recordQuery"
          style="
            display: inline-block;
            text-decoration: none;
            height: 20px;
            line-height: 20px;
            padding-left: 2px;
          "
        >
          <p class="copy">{{ this.ICP }}</p></a
        >
        <a
          v-if="this.isKK"
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=35060202000542"
          style="
            display: inline-block;
            text-decoration: none;
            height: 20px;
            line-height: 20px;
            padding-left: 4px;
          "
          ><img src="../assets/备案图标 (2).png" style="float: left" />
          <p class="copy">闽公网安备 35060202000542号</p></a
        >
      </div>
    </div>
  </div>
</template>
<script>
import { useStore } from "vuex";
export default {
  data() {
    return {
      store: useStore(),
      isZ: false,
      isKK: true,
      name: "福建科控自动化科技有限公司",
      site: "福建省漳州市芗城区嘉宏广场",
      phone: "18759688095",
      email: "fjkkauto@163.com",
      wx: "wxid_0z0q5dub5jx122",
      ICP: "",
    };
  },
  mounted() {
    const user = this.store.state.userInfo;
    this.isZ = user ? (user.permission ? user.permission == 0 : false) : false;
    const host = window.location.host;
    this.isKK = host.includes("fjkkauto");
    this.name = this.isKK ? "福建科控自动化科技有限公司" : "北京凯创通达科技有限公司";
    this.site = this.isKK ? "福建省漳州市芗城区嘉宏广场" : "北京副中心CBD中央商务区";
    this.phone = this.isKK ? "18759688095" : "13011801198";
    this.email = this.isKK ? "fjkkauto@163.com" : "bjkctd@163.com";
    this.wx = this.isKK ? "wxid_0z0q5dub5jx122" : "13011801198";
    this.ICP = this.isKK ? "闽ICP备2022016214号" : "京ICP备2022025259号";
  },
  methods: {
    doProductRouter(brandType) {
      if (brandType) {
        this.$router.push("/ProductPage?type=" + brandType);
      } else {
        this.$router.push("/ProductPage?type=" + brandType);
      }
    },
    doCaseRouter(ca) {
      if (ca) {
        this.$router.push("/ServicePage?name=" + ca);
      } else {
        this.$router.push("/ServicePage");
      }
    },
    doService(ser) {
      if (ser) {
        this.$router.push("/CasePage");
      } else {
        this.$router.push("/CasePage");
      }
    },
    doUsRoter() {
      this.$router.push("/JobPage");
    },
  },
};
</script>
<style>
.footer_bar {
  height: 262px;
  background: #2c3e50;
  color: #fff;
}
.links {
  width: 22%;
  text-align: center;
}
.linkss {
  width: 33%;
  text-align: center;
}
.line_title {
  height: 30px;
  line-height: 30px;
}
.link_item_title {
  padding-bottom: 20px;
}
.foot_title {
  height: 30px;
  line-height: 40px;
  font-size: 18px;
}
.link_item_title a {
  height: 30px;
  line-height: 40px;
  font-size: 18px;
  color: #e7f0fa;
  width: 100%;
  text-decoration: none;
  cursor: pointer;
}
.link_item_title a:hover {
  color: #f88053;
}
.link_item {
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  color: #b3c7dc;
  /* display: inline-block; */
  width: 100%;
  cursor: pointer;
}
.link_item a {
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  color: #b3c7dc;
  /* display: inline-block; */
  width: 80px;
  text-decoration: none;
}
.link_item a:hover {
  color: #f88053;
}
.beian {
  font-size: 14px;
  text-align: center;
  height: 40px;
  line-height: 40px;
}
.name {
  height: 45px;
  line-height: 45px;
  font-size: 20px;
}
.address {
  margin: auto;
  height: 30px;
  line-height: 45px;
  color: #f8b053;
  padding-bottom: 10px;
}
.desc_items {
  line-height: 30px;
  font-size: 14px;
}
.split_line {
  width: 1px;
  background: #efefef;
}
.qrcode {
  width: 150px;
  text-align: center;
  padding-top: 10px;
  padding-left: 50px;
  position: relative;
}
.qrcode img {
  width: 200px;
}
.qrcode div {
  position: absolute;
  height: 30px;
  line-height: 30px;
  width: 200px;
  bottom: 1%;
}
.flex-item img {
  width: 18px;
}
.look-us {
  font-size: 16px;
  color: #b3c7dc;
  height: 40px;
  line-height: 45px;
  cursor: pointer;
}
.look-us:hover {
  color: #f88053;
}
.min-logo {
  padding-right: 10px;
}
.copyright {
  /* width: 1000px; */
  margin: 0 auto;
  padding-top: 25px;
  text-align: center;
  display: flex;
  justify-content: center;
}
.copy {
  float: left;
  height: 20px;
  line-height: 20px;
  margin: 0px 0px 0px 5px;
  color: #939393;
}
</style>
